import * as z from "zod";

export const getFinaleLocations = {
  name: "getFinaleLocations" as const,
  input: z.object({}),
  output: z.object({
    locations: z.array(
      z.object({
        externalId: z.string(),
        name: z.string(),
        address1: z.string().nullable(),
        city: z.string().nullable(),
        provinceCode: z.string().nullable(),
        shippingName: z.string().nullable(),
      }),
    ),
  }),
};
